export default __webpack_public_path__ + "static/media/hessen_dark.0190ad8a.png";